import { defer } from "react-router-dom";
import { getCommonAttrs } from "@didi/x-tracker";
import { resolveLoaderResult } from "@/routes/loaderResult";
import { TabType } from "./common/config";
import { getVoucherPageInfo, queryVoucherList } from "./common/services";

export function couponsListLoader() {
  const commonAttrs = getCommonAttrs();

  return defer({
    coreData: resolveLoaderResult(getVoucherPageInfo()),
    initialListData: resolveLoaderResult(
      queryVoucherList({
        pageSize: 10,
        currentPageNum: 1,
        sofiUid: commonAttrs.pub_uid,
        tabType: TabType.VALID,
      }),
    ),
  });
}
